import styled from "styled-components";

export const Padding = styled.div`
  padding: ${({padding}) => padding};
`;